import React from 'react'
import { CreditApplication } from '_gql'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { FormattedMessage } from '@divvy-web/i18n'

import ImageWrapper from '@sputnik/components/ImageWrapper'
import { getPaymentNetwork } from '@sputnik/components/utils'
import StatusTile from '@sputnik/pages/Dashboard/StatusTile/StatusTile'

interface MigrationPendingStatusTileProps {
  creditApp: CreditApplication
}

const MigrationPendingStatusTile = ({ creditApp }: MigrationPendingStatusTileProps) => {
  const [makeTestId] = useNameFormatter('MigrationPendingStatusTile')
  const { dsaVersion } = creditApp || {}
  const paymentNetwork = getPaymentNetwork(dsaVersion)

  return (
    <div data-testid={makeTestId('')}>
      <StatusTile
        creditApp={creditApp}
        image={
          <ImageWrapper
            alt='bird flying'
            imageName='dashboard-application-visa-pending-status'
          />
        }
        primaryInfo={
          <FormattedMessage
            defaultMessage="Your request has been received. We will update you once it's complete."
            id='sputnik.MigrationPendingStatusTile__ZlV6yr'
          />
        }
        title={
          <FormattedMessage
            defaultMessage='Pending {paymentNetwork} migration approval'
            id='sputnik.MigrationPendingStatusTile__qKTNQX'
            values={{ paymentNetwork }}
          />
        }
      />
    </div>
  )
}

export default MigrationPendingStatusTile
